import Skeleton from 'react-loading-skeleton';

const PaypalButtonSkeleton = () => {
  return (
    <div className="absolute animate-pulse rounded">
      <Skeleton count={1} className="h-8 w-64 bp1:h-10 bp1:w-96" />
    </div>
  );
};

export default PaypalButtonSkeleton;
